import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { spaceM, space4XL, xdlColorText } from '@xing-com/tokens';

export const List = styled.ol`
  padding: 0;
  display: flex;
  gap: ${spaceM};
  flex-wrap: wrap;
  margin-bottom: ${space4XL};
`;

export const ListItem = styled.li`
  display: inline-block;
  list-style: none;
`;

export const Link = styled.a`
  color: ${xdlColorText};
`;

export const MoreButton = styled(TextButton)`
  margin-left: ${spaceM};
`;
